<template>
        <div class="right-time">{{$t("updateAt")}}{{time}}</div>
</template>

<script>
export default {
  name: "updatetime",
  props: {
      time:String
  },
};
</script>

<style scoped>
.right-time {
  font-size: 0.2rem;
  line-height: 0.2rem;
  padding-right: 0.12rem;
}
</style>


// WEBPACK FOOTER //
// src/components/common/updatetime.vue